import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 根据jobUuid查询装箱明细
export function unitLoadDeviceUsagesByJobUuid(params) {
  return request({
    url: URL.seaExport.unitLoadDeviceUsagesByJobUuid,
    method: 'get',
    params
  })
}
// 导入excel
export function importExcelData(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.usageImportExcelData,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}
